export default __webpack_public_path__ + "static/media/second_introduction_image.5138c8ec.svg";